import {
  AudienceFilter,
  defineMessage,
  defineTopic,
  TopicMessages,
} from 'magpie-lib/models';
import * as t from 'ts-schema';

const hostNavigateMessage = defineMessage({
  type: '@@video-components-external/utility/host-navigate' as const,
  payloadSchema: t.object({
    location: t.string,
    newTab: t.boolean,
  }),
});

export const UtilityMessages = {
  hostNavigateMessage,
};

export const utilityTopicDef = defineTopic({
  name: '@@video-components-external/utility/utils' as const,
  messages: [UtilityMessages.hostNavigateMessage],
  enableRuntimeValidation: false,
  audience: AudienceFilter.builder().build(),
});

export type UtilityMessage = TopicMessages<typeof utilityTopicDef>;
